import { Component, OnInit } from '@angular/core';
import { AuthService } from '@common/services';
import { readSupportSession, SupportSessionInfo } from '@modules/auth/models';

@Component({
    selector: 'fina-support-session-banner',
    template: `
        <div *ngIf="session" class="support-session-banner shadow">
            <i class="fas fa-user-shield me-2"></i>
            <span>
                Sesión de soporte<span *ngIf="session.createdBy"> · {{ session.createdBy }}</span> · vence a las
                {{ session.expiresAt | date : 'shortTime' }}
            </span>
            <button type="button" class="btn btn-sm btn-light ms-3" (click)="end()">Salir</button>
        </div>
    `,
    styles: [
        `
            .support-session-banner {
                position: fixed;
                bottom: 1rem;
                left: 50%;
                transform: translateX(-50%);
                z-index: 1080;
                display: flex;
                align-items: center;
                padding: 0.5rem 1rem;
                border-radius: 2rem;
                background: #c0392b;
                color: #fff;
                font-size: 0.875rem;
                white-space: nowrap;
            }
        `,
    ],
})
export class SupportSessionBannerComponent implements OnInit {
    session: SupportSessionInfo | null = null;

    constructor(private authService: AuthService) {}

    ngOnInit() {
        this.session = readSupportSession();
    }

    end() {
        this.authService.logout();
    }
}
